/**
 * Razas de perro que el personal puede elegir al registrar un perro.
 *
 * Son los nombres tal como se usan en el día a día en Happy Tails (Salchicha,
 * Criollo, Mix, Blue Heeler), no los nombres oficiales de la FCI: la lista sirve
 * para que todos escriban la misma raza igual, no para ser un catálogo canino.
 *
 * Al agregar una raza: nombre en español, acentos incluidos, y mantener el orden
 * alfabético. Si una raza que ya está en la base de datos recibe aquí otro
 * nombre, agrega también el nombre viejo como alias en
 * happy-tails-backend/constants/breeds.js para que los registros existentes se
 * normalicen al mismo valor.
 *
 * Una raza fuera de la lista se captura con "Otro (especificar)" en el
 * formulario, así que nadie se queda sin poder registrar un perro.
 */

export const DOG_BREEDS = [
    'Affenpinscher',
    'Afgano',
    'Airedale Terrier',
    'Akita',
    'Alaskan Malamute',
    'American Bully',
    'American Staffordshire Terrier',
    'Antiguo Pastor Inglés',
    'Basenji',
    'Basset Hound',
    'Beagle',
    'Bedlington Terrier',
    'Bernés de la Montaña',
    'Bichón Frisé',
    'Bloodhound',
    'Blue Heeler',
    'Border Collie',
    'Border Terrier',
    'Borzoi',
    'Boston Terrier',
    'Boxer',
    'Boyero de Flandes',
    'Braco Alemán',
    'Bull Terrier',
    'Bulldog Francés',
    'Bulldog Inglés',
    'Bullmastiff',
    'Cairn Terrier',
    'Cane Corso',
    'Cavalier King Charles Spaniel',
    'Chihuahua',
    'Chow Chow',
    'Cockapoo',
    'Cocker Americano',
    'Cocker Spaniel',
    'Collie',
    'Corgi',
    'Coton de Tulear',
    'Criollo',
    'Dálmata',
    'Doberman',
    'Dogo Argentino',
    'Dogo de Burdeos',
    'Fox Terrier',
    'Galgo Español',
    'Gigante de los Pirineos',
    'Golden Retriever',
    'Goldendoodle',
    'Gran Danés',
    'Greyhound',
    'Grifón',
    'Havanés',
    'Husky Siberiano',
    'Jack Russell',
    'Kelpie Australiano',
    'Komondor',
    'Labradoodle',
    'Labrador Retriever',
    'Lebrel Irlandés',
    'Lhasa Apso',
    'Maltipoo',
    'Mastín Español',
    'Mastín Napolitano',
    'Mix',
    'Pastor Alemán',
    'Pastor Australiano',
    'Pastor Belga',
    'Pastor Belga Malinois',
    'Pastor Blanco Suizo',
    'Pastor Caucásico',
    'Pastor de Shetland',
    'Pequinés',
    'Pinscher Miniatura',
    'Pitbull',
    'Pointer',
    'Pomeranian',
    'Pomsky',
    'Poodle',
    'Pug',
    'Rhodesian Ridgeback',
    'Rottweiler',
    'Salchicha',
    'Saluki',
    'Samoyedo',
    'San Bernardo',
    'Schnauzer',
    'Schnauzer Gigante',
    'Schnauzer Miniatura',
    'Scottish Terrier',
    'Setter Irlandés',
    'Shar Pei',
    'Shiba Inu',
    'Shih Tzu',
    'Spitz Japonés',
    'Springer Spaniel',
    'Staffordshire Bull Terrier',
    'Terrier Irlandés',
    'Vizsla',
    'Weimaraner',
    'West Highland White Terrier',
    'Whippet',
    'Xoloitzcuintle',
    'Yorkshire Terrier',
];

// Las más capturadas en recepción. Se muestran primero cuando nadie ha escrito
// nada en el buscador, para no obligar a teclear lo más común.
export const COMMON_BREEDS = [
    'Mix',
    'Criollo',
    'Salchicha',
    'Chihuahua',
    'Schnauzer',
    'Shih Tzu',
    'Border Collie',
    'Beagle',
    'Corgi',
    'Pug',
    'Blue Heeler',
    'Pastor Australiano',
];

// Valor que marca "esta raza no está en la lista" en el selector. Nunca se
// guarda: al elegirlo, el formulario guarda el texto que escribió el personal.
export const OTHER_BREED = '__otro__';
